import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form } from "semantic-ui-react";
import { useFormContext } from "react-hook-form";

// Helpers & Hooks
import useAgeVerificationForm from "@common/components/hooks/useAgeVerificationForm";
import { getCurrentDateTime } from "@common/components//helpers/datetime";

// Actions
import AgeVerificationAction from "@common/redux/actions/AgeVerificationAction";

// Components
import ToggleComponent from "@common/components/shared/forms/ToggleComponent";
import DateAndTimeGroup from "@common/components/shared/forms/DateAndTimeGroup";
import FormButtonsComponent from "@common/components/shared/forms/FormButtonsComponent";
import TextareaComponent from "@common/components/shared/forms/TextareaComponent";
import CustomerHasIdForm from "./CustomerHasIdForm";
import CustomerHasNoIdForm from "./CustomerHasNoIdForm";
import StandardHiddenInputs from "../forms/StandardHiddenInputs";
import useLogin from "../../hooks/useLogin";
import { setComplianceFormDateTime } from "../../helpers/datetime";

const AgeVerificationForm = (props) => {
  const formData = props.data;

  const form = useFormContext();
  const {
    control,
    register,
    watch,
    setValue,
    handleSubmit,
    formState: { errors, isValid },
  } = form;

  const hasId = watch("hasId");

  const { resetForm, onSubmit, onError } = useAgeVerificationForm({
    formData,
    form,
  });

  const [{ isDesktop }] = useLogin();

  useEffect(() => {
    if (!isDesktop) {
      setComplianceFormDateTime(setValue);
    }
  }, []);

  return (
    <Form className="form-padding" onSubmit={handleSubmit(onSubmit, onError)}>
      <StandardHiddenInputs />
      <DateAndTimeGroup
        control={control}
        dateFormat="YYYY-MM-DD"
        errorsDate={errors.date}
        errorsTime={errors.time}
        maxDate={getCurrentDateTime()}
      />

      <ToggleComponent
        control={control}
        name="hasId"
        label="Customer has ID?"
        error={errors.hasId}
      />

      {hasId !== null && (
        <>
          {hasId ? (
            <CustomerHasIdForm
              idTypes={formData.idTypes}
              genders={formData.genders}
              idOther={formData.idOther}
            />
          ) : (
            <CustomerHasNoIdForm />
          )}

          <TextareaComponent
            name="comments"
            label="Comments"
            placeholder="Please enter comments..."
            register={register}
            error={errors.comments}
            fieldStyle="py-1"
          />

          <FormButtonsComponent
            isValid={isValid}
            centered={true}
            resetForm={() => resetForm(false)}
          />
        </>
      )}
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    data: AgeVerificationAction.getStatePath(state),
  };
};

export default connect(mapStateToProps)(AgeVerificationForm);
